import React, { Component } from 'react';

import './style.css';

import Header from '../Header';
import Footer from '../Footer';

class PrivacyPolicy extends Component {


  render() {
    return (
      <div className='PrivacyPolicy'>
        <Header></Header>
        <div className="term-conditions">
        <h3>Privacy Policy of Right Track Admizzionz Campuz Pvt. Ltd.</h3>
        <p>This page is informs our website visitors about the privacy and data protection policies of Right Track Admizzionz Campuz Pvt. Ltd. which operates the website <a href="www.admizzionzcampuz.com">www.admizzionzcampuz.com</a> with respect to its online services. This policy covers, inter alia, terms relating to the collection, receipt, possession, storage, use, disclosure, handling and dealing of personal information provided by our visitors and users when they avail our online services. </p>

        

        <h4>What personal information do we collect?</h4>
        <p>We collect minimal information from you when you register or fill up an enquiry form on our website. When registering on our site or filling up a form you may be asked to enter your name, date of birth, mobile number, e-mail-id and address. This information is necessary for us to record basic identity of our users, communicate with them over e-mail or SMS and provide answers to their queries.  You may <b>visit</b> our site anonymously. However, no online services can be availed/registered for on our website without providing the aforesaid necessary information. 
          </p>

        <p>Our visitors and users can access, review and update the personal information provided to us to maintain accuracy of such information. However, we are not responsible, and cannot be held liable in any manner, for the accuracy or authenticity of this information.
          </p>
        

        <h4>What do we use your information for?</h4>
        <p>The personal information we collect from you may be used for one of the following purposes:</p>
        <ul>
          <li>
          To provide answers to the queries raised by our visitors
        </li>
        <li>
        To improve our website based on the information and feedback from you
        </li>
        <li>
        To improve our customer experience
        </li>
        <li>
        To process transactions if you choose to register for our products and services
        </li>
        <li>
        To conduct research along with higher education institutions 
        </li>
        <li>
        To e-mail or SMS you periodically to update you about our products and services
        </li>
        <li>
        To administer a survey or a promotion relating to our products and services
          </li>
        </ul>
        <p>It is reiterated that the personal information collected by us will not be used for any purpose other than that identified above.</p>

        

        <h4>Do we disclose any information to outside parties?</h4>
        <p>We do not sell, exchange, transfer or disclose your personal information to any other third-party organization. </p>

        

        <h4>How do we protect your information?</h4>
        <p>We implement a variety of security measures to maintain the safety of your personal information. While the security of your personal information is important to us, remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.</p>

        

        <h4>Do we use cookies?</h4>
        <p>No, we do not use cookies.</p>

        

        <h4>Do we collect Log Data?</h4>
        <p>We want to inform you that whenever you visit our website, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer's Internet Protocol (“IP”) address, browser version, pages of our website that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p>

        

        <h4>Do we employ third party service providers?</h4>
        <p>We may employ third-party companies and individuals:</p>
        <ul>
          <li>
        To host our website
        </li>
        <li>
        To facilitate our services</li>
        <li>
        To assist us in analyzing how our website is performing
        </li>
        <li>
        To process payment requests received from our website
        </li>
        </ul>
        <p>We want to inform you that these third parties may have access to your personal information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to collect, receive, possess, store, use, disclose, handle or deal with the personal information for any other purpose.
          </p>

        

        <h4>Do we have links to other sites?</h4>
        <p>Our website may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the privacy policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

        

        <h4>Do we maintain children’s privacy?</h4>
        <p>Our website does not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to take necessary action.</p>

        <p>With respect to persons between the age of 13 and 18, parental guidance and consent for submission of personal information to us is necessary. This consent is obtained at an appropriate page on our website and we maintain a record of such consent. A parent may withdraw its consent at a later stage by providing us a notice in writing in this regard.</p>

        

        <h4>How will we communicate changes to this privacy policy?</h4>
        <p>We may update our Privacy Policy from time to time in accordance with applicable law. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new privacy policy on this page. These changes will be effective immediately after they are posted on this page.
          </p>

        

        <h4>Is this privacy policy applicable online only?</h4>

        <p>Yes, this is our online privacy policy for the website <a href="www.admissionsalert.com">www.admissionsalert.com</a> and applies to information collected through it only.</p>

        

        <h4>Consent</h4>
        <p>The visitors to our website and users of our online services consent to the collection, receipt, possession, storage, use, disclosure, handling and dealing of personal information provided by them in the manner set forth above. This consent is obtained at an appropriate page on our website and we maintain a record of such consent. A visitor/user may withdraw its consent at a later stage by providing us a notice in writing in this regard.  </p>

        

        <h4>Period of retention of personal information </h4>
        <p>The personal information received by us will be retained only for a period of 3 years after the completion of services provided by us to the user.</p>

        

        <h4>Contact Us</h4>
        <p>If you have any questions or suggestions about our privacy policy, do not hesitate to contact us. In case you have any grievance with respect to the collection, receipt, possession, storage, use, disclosure, handling and dealing of your information by us, please contact <a href="info@admizzionzcampuz.com">info@admizzionzcampuz.com</a></p>
        </div>
        <Footer></Footer>
      </div>
    );
  }
}

export default PrivacyPolicy;



/** WEBPACK FOOTER **
 ** ./src/components/PrivacyPolicy/index.js
 **/